import React from 'react';
import { css, toList } from '../../lib/render.jsx';

export default function Confetti({ v }) {
  if (!v.hasConfetti) return null;
  return (
    <>
      <div style={{ "position": "fixed", "inset": "0", "pointerEvents": "none", "zIndex": "95", "overflow": "hidden" }}>
        {' '}
        {toList(v.confetti).map((c, $index) => (
          <React.Fragment key={$index}>
            {' '}
            <span style={css(c?.style)} />
            {' '}
          </React.Fragment>
        ))}
        {' '}
      </div>
    </>
  );
}
